/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Role {
  None = 0,
  Customer = 1,
  CaseManager = 2,
  FirstLine = 4,
  Administrator = 8,
}
